import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'react-native-modalfy';

import { IconTouchable } from '../../common/IconTouchable';
import { IS_MOBILE } from '@utils';
import { modals, ModalStackParamsType } from '@modals';
import { usePopover } from '@hooks';
import { PickerPopover } from '../PickerPopover';
import { useVideoPlayerSettings } from './hooks/useVideoPlayerSettings';

export interface IPlaybackRateMenuProps {
  onVisibleChange?(value: boolean): void;
}

type OptionType = {
  title: string;
  value: number;
};

export const PlaybackRateMenu = observer<IPlaybackRateMenuProps>(
  ({ onVisibleChange }) => {
    const videoPlayerSettings = useVideoPlayerSettings();
    const { t } = useTranslation();
    const modal = useModal<ModalStackParamsType>();
    const popover = usePopover();

    const options = useMemo<OptionType[]>(() => {
      return [
        { title: t('common.videoPlayer.normal'), value: 1 },
        { title: '1.25x', value: 1.25 },
        { title: '1.5x', value: 1.5 },
        { title: '1.75x', value: 1.75 },
        { title: '2x', value: 2 },
      ];
    }, []);

    function switchSubtitles(item: OptionType) {
      popover.togglePopover();
      videoPlayerSettings.setPlaybackRate(item.value);
    }

    function openSubtitlesModal() {
      modal.openModal(modals.PickerModal, {
        selectedValue: videoPlayerSettings.playbackRate,
        onSelect: (item) =>
          videoPlayerSettings.setPlaybackRate(item.value),
        options,
      });
    }

    if (IS_MOBILE) {
      return (
        <IconTouchable
          name="speed-bold"
          color="$background0"
          onPress={openSubtitlesModal}
        />
      );
    }

    return (
      <PickerPopover
        ref={popover.ref}
        options={options}
        onSelect={switchSubtitles}
        onVisibleChange={onVisibleChange}
        selectedValue={videoPlayerSettings.playbackRate}
      >
        <IconTouchable
          name="speed-bold"
          color="$background0"
          onPress={popover.togglePopover}
        />
      </PickerPopover>
    );
  },
);
